import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import AdminLayout from "../../components/layout/AdminLayout/AdminLayout";
import galleryService from "../../services/gallery/galleryService";
import sweetAlert from "../../utils/sweetAlert";
import { toast } from "react-toastify";

import "./Gallery.css";

export default function GalleryList() {

    const [gallery, setGallery] = useState([]);

    const [loading, setLoading] = useState(true);

    const [page, setPage] = useState(1);

    const [pageSize] = useState(10);

    const [search, setSearch] = useState("");

    const [totalPages, setTotalPages] = useState(0);

    useEffect(() => {
        loadGallery();
    }, [page, search]);

    const loadGallery = async () => {

        try {

            setLoading(true);

            const response = await galleryService.getList(
                page,
                pageSize,
                search
            );

            if (response.success) {

                setGallery(response.data.items);

                setTotalPages(response.data.totalPages);

            }

        }
        catch (error) {

            console.log(error);

        }
        finally {

            setLoading(false);

        }

    };
    const handleDelete = async (id) => {

        const confirmed = await sweetAlert.confirmDelete();

        if (!confirmed) {

            return;

        }

        try {

            const response = await galleryService.delete(id);

            if (response.success) {

                toast.success(response.message);

               loadGallery();

            }
            else {

                toast.error(response.message);

            }

        }
        catch (error) {

            console.log(error);

            toast.error("Something went wrong.");

        }

    };
    return (

        <AdminLayout>

            <div className="page-header">

                <h2>Gallery</h2>

                <Link
                    to="/gallery/add"
                    className="btn btn-primary"
                >
                    Add Gallery
                </Link>

            </div>
            <div className="d-flex mb-3 gap-2">
                <input
                    type="text"
                    className="form-control"
                    placeholder="Search Gallery..."
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                />

                <button
                    className="btn btn-primary"
                    disabled={loading}
                    onClick={() => setPage(1)}
                >
                    Search
                </button>
            </div>
            <div className="card">

                <div className="card-body">

                    <table className="table table-bordered">

                        <thead>
    <tr>
        <th>Photo</th>
        <th>Title</th>
        <th>Category</th>
        <th>Status</th>
        <th width="170">Action</th>
    </tr>
</thead>

                        <tbody>

                            {
                                loading ?

                                    <tr>
                                        <td colSpan="4" className="text-center">
                                            Loading...
                                        </td>
                                    </tr>

                                    :

                                    gallery.length === 0 ?

                                        <tr>
                                            <td colSpan="4" className="text-center">
                                                No Gallery Found
                                            </td>
                                        </tr>

                                        :

                                        gallery.map(item => (

                                            <tr key={item.galleryId}>

    <td>
        {
            item.photoName &&
            <img
                src={`${process.env.REACT_APP_SERVER_URL}${item.photoName}`}
                alt={item.title}
                style={{
                    width: "60px",
                    height: "60px",
                    objectFit: "cover",
                    borderRadius: "6px"
                }}
            />
        }
    </td>

    <td>{item.title}</td>

    <td>{item.category}</td>

    <td>
        {
            item.isActive
                ? <span className="badge bg-success">Active</span>
                : <span className="badge bg-danger">Inactive</span>
        }
    </td>

    <td>

        <Link
            to={`/gallery/edit/${item.galleryId}`}
            className="btn btn-warning btn-sm me-2"
        >
            Edit
        </Link>

        <button
            className="btn btn-danger btn-sm"
            onClick={() => handleDelete(item.galleryId)}
        >
            Delete
        </button>

    </td>

</tr>

                                        ))
                            }

                        </tbody>

                    </table>

                </div>

            </div>

        </AdminLayout>

    );

}